import { Scene } from "pixi-scenegraph";
import { HEIGHT, WIDTH } from "@/constants";
import { createMenuItem, createPanel , createText} from '@/ui/menu-builder';

const BUTTON_HEIGHT = 40, PADDING = BUTTON_HEIGHT * 0.5;
const DEFAULT_MESSAGE = `An unexpected error occurred. This should not happen\nand I'll churn these out one after another.\n\nIf you want to help me and speed up this process, please take a screenshot of the stack trace below\nand post it in steam discussions.\n\n`
export class ErrorScene extends Scene {

    constructor() {
        super("error"); // this is the scene name
        const errorMessage = createText({
            text: 'An unknown occurred :(',
            fill: ['0xd67132'],
            fontSize: 18,
            align: 'left',
            dropShadow: false,
            dropShadowBlur: 0
        });

        errorMessage.position.set(WIDTH / 2, 280);
        this.errorMessage = errorMessage;
        const back = createMenuItem({
            text: 'Back to menu', 
            yCoord: HEIGHT / 2 + 100,
            clickActionName: 'NAVIGATE',
            clickActionPayload: {
                sceneName: 'menu'
            },
            variation: '15'
        });
        this.addChild(back);
        this.addChild(errorMessage);
    }

    setPayload(payload) {
        this.errorMessage.text = DEFAULT_MESSAGE;
        if (payload && payload.stack) {
            this.errorMessage.text += payload.message?.toString() + '\n' + payload?.stack;
        }
    }
}